import React from "react";
import Loader from "../../../components/loader";
import { useFormik } from "formik";
import { Link } from "react-router-dom";
import ClerksByOrderForm from "../../../forms/ClerksByOrderForm";
import TableClerksByOrder from "../../../components/reports/TableClerksByOrder";
import { ReportByClerksOrder } from "../../../models/ReportByClerksOrder";
import ReportByClerksOrdersSchema from "../../../validations/ReportByClerksOrdersSchema";
import axiosClient from "../../../config/axios";
import moment from "moment";

const ClerksByOrder = () => {
  const [loading, setLoading] = React.useState(false);
  const [records, setRecords] = React.useState([]);
  const [orders, setOrders] = React.useState([]);
  const [clerks, setClerks] = React.useState([]);
  const [status, setStatus] = React.useState([]);
  const hasDataLoaded = React.useRef(false);

  const fetchData = async () => {
    try {
      const responseClerks = await axiosClient.get("/users/allClerks-active");
      const formattedOptionsClerks = [
        { value: "all", label: "Todas las opciones" },
        ...responseClerks.data.data.map((clerk) => ({
          value: clerk.id,
          label: (clerk.name + ' ' + clerk.first_surname + ' ' + (clerk.second_surname ? clerk.second_surname : '')).trim(),
        })),
      ];
      setClerks(formattedOptionsClerks);

      const responseStatus = await axiosClient.get("/orderStatuses/allWithOrderCount");
      const formattedOptionsStatus = [
        { value: "all", label: "Todas las opciones" },
        ...responseStatus.data.data.map((status) => ({
          value: status.id,
          label: status.order_status,
        })),
      ];
      setStatus(formattedOptionsStatus);
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...ReportByClerksOrder(),
      orderType: "Normal",
    },
    validationSchema: ReportByClerksOrdersSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const adjustedStart = moment(values.start).format("YYYY-MM-DD");
        const adjustedEnd = moment(values.end).format("YYYY-MM-DD");
        const dataTable = [];

        const endpoint = `/reports/Clerk-by-order?start=${adjustedStart}&end=${adjustedEnd}&Clerk_id=${values.clerk}&status=${values.status}`;
        const { data: clerkData } = await axiosClient.get(endpoint);
        console.log("clerkData", clerkData);
        clerkData?.forEach((record) => {
          const { clerk, orders } = record;

          if (!orders || orders.length === 0) {
            dataTable.push({
              clerk,
              tipo: "Normal",
              subtotal: 0,
              orden_en_cero: true,
              totalDistance: 0,
              sin_orden: true,
            });
            return;
          }

          orders.forEach((order) => {
            const { subtotal, orden_en_cero, totalDistance, OrderOperators, ...rest } = order;
            dataTable.push({
              ...rest,
              operadores: OrderOperators ? OrderOperators : [],
              subtotal: orden_en_cero ? 0 : subtotal,
              orden_en_cero: orden_en_cero || false,
              clerk,
              totalDistance,
              tipo: "Normal",
            });
          });
        });

        dataTable.sort(
          (a, b) =>
            new Date(a.fecha_hora_reporte) - new Date(b.fecha_hora_reporte)
        );

        // === Filtrar las órdenes según el tipo seleccionado ===
        const filteredOrders =
          values.orderType && values.orderType !== "all"
            ? dataTable.filter((order) => order.tipo === values.orderType)
            : dataTable;

        setOrders(filteredOrders);

        // === Agrupar por operador (para exportar a Excel) ===
        const groupedRecords = {};

        filteredOrders.forEach((order) => {
          const clerk = order.clerk;
          const clerkId = clerk?.id;
          if (!clerkId || order.sin_orden) return;

          if (!groupedRecords[clerkId]) {
            groupedRecords[clerkId] = {
              clerk,
              orders: [],
            };
          }

          groupedRecords[clerkId].orders.push({
            Order: {
              id: order.id,
              folio: order.folio,
              subtotal: order.subtotal,
              orden_en_cero: order.orden_en_cero || false,
              fecha_hora_reporte: order.fecha_hora_reporte,
              grua: order.grua,
              auxilio_vial: order.auxilio_vial,
              montacarga: order.montacarga,
              corresponsalia: order.corresponsalia,
              taxi: order.taxi,
              tipoServicio: order.tipoServicio,
              tipo: order.tipo,
              razon: order.razon,
              comisionPorGrua: order.comisionPorGrua,
              operadores: order.OrderOperators ? order.OrderOperators : [],
            },
            totalDistance: order.totalDistance || 0,
          });
        });

        // === Convertir a arreglo y ordenar las órdenes dentro de cada operador ===
        const combinedRecords = Object.values(groupedRecords).map((record) => {
          record.orders.sort(
            (a, b) =>
              new Date(a.Order?.fecha_hora_reporte) -
              new Date(b.Order?.fecha_hora_reporte)
          );
          return record;
        });

        setRecords(combinedRecords);

        hasDataLoaded.current = true;
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  React.useEffect(() => {
    fetchData();
    formik.handleSubmit();
  }, []);

  return (
    <React.Fragment>
      <Loader isLoading={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item active">
              Reporte de oficinistas por ordenes
            </li>
          </ol>
          <h1 className="page-header mb-0">Reporte de oficinistas por ordenes</h1>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-xl-12 card border-0 p-3">
          <div className="card-body">
            <ClerksByOrderForm
              formik={formik}
              clerks={clerks}
              status={status}
              records={records}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 card border-0 p-3">
          <TableClerksByOrder
            orders={orders}
            start={formik.values.start}
            end={formik.values.end}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ClerksByOrder;